import { organisationConstants } from '../../../_constants';

const initialState = { deleteManageMetricLoading: true, data: '', error: false };

export function DeleteManageMetric(state = initialState, action) {
    
    switch (action.type) {
        case organisationConstants.REQUEST_DELETE_MANAGE_METRIC:
            return {
                deleteManageMetricLoading: true,
                data: '',
                error: false
            };
        case organisationConstants.RECEIVE_DELETE_MANAGE_METRIC:
            return {
                deleteManageMetricLoading: false,
                data: action.manageMetricList,
                error: false
            };
        case organisationConstants.DELETE_MANAGE_METRIC_ERROR:
            return {
                deleteManageMetricLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/manageMetric/deleteManageMetric.reducer.js